/**
 * Small centered confirm dialog (iOS-alert style), used by
 * EventDetailSheet for the delete confirmation. Generic enough to
 * reuse elsewhere later.
 */
export default function ConfirmDialog({ open, message, confirmLabel = '削除', onConfirm, onCancel, danger = true }) {
  return (
    <>
      <div className={`confirm-overlay${open ? ' show' : ''}`} onClick={onCancel} />
      <div className={`confirm-dialog${open ? ' show' : ''}`} role="alertdialog" aria-modal="true">
        <p>{message}</p>
        <div className="confirm-actions">
          <button className="btn btn-tonal" type="button" onClick={onCancel}>
            キャンセル
          </button>
          <button
            className={`btn ${danger ? 'btn-danger' : 'btn-filled'}`}
            type="button"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </>
  );
}
